export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="py-24 md:py-32 bg-[#faf8f5] text-[#1f281e] border-b border-[#2d4a22]/10"
  >
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 reveal">
          <figure className="img-zoom relative aspect-[3/4] bg-[#ebdccb] overflow-hidden border border-[#2d4a22]/20">
            <img
              src="https://images.unsplash.com/photo-1734303023491-db8037a21f09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGVyJTIwZXZhbHVhdGluZyUyMGxhd258ZW58MHx8fHwxNzkyOTYxNzQxfDA&ixlib=rb-4.1.0&q=85"
              alt="Landscaper evaluating a lawn on a job site"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <figcaption className="absolute bottom-0 left-0 right-0 p-6 text-xs uppercase tracking-widest text-[#faf8f5] font-bold bg-gradient-to-t from-[#1f281e]/85 to-transparent">
              Juan Sahagun &nbsp;·&nbsp; Sales Specialist
            </figcaption>
          </figure>
        </div>

        <div className="lg:col-span-7 reveal reveal-d1">
          <span className="font-mono-type text-xs uppercase tracking-[0.18em] text-[#2d4a22] font-semibold block mb-2">
            Direct Accountability
          </span>
          <h2 className="font-display text-3xl md:text-5xl uppercase text-[#1f281e] mb-6">
            Family-Owned. Juan Oversees Every Site.
          </h2>
          <p className="text-base text-[#3d4b3b] leading-relaxed mb-6">
            We do not pass your yard to subcontractors. From the initial estimate to final sod roll and irrigation
            calibration, sales specialist Juan Sahagun personally ensures every cut meets our standard.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-6 border-t border-[#2d4a22]/15">
            <div>
              <span className="text-xs uppercase font-bold text-[#2d4a22] block mb-1">Headquarters</span>
              <p className="text-sm text-[#1f281e]" data-testid="about-address">
                15306 Castana Ave
                <br />
                Paramount, CA 90723
              </p>
            </div>
            <div>
              <span className="text-xs uppercase font-bold text-[#2d4a22] block mb-1">Direct Line</span>
              <a
                href="tel:+13232204640"
                className="text-sm text-[#1f281e] font-semibold hover:text-[#2d4a22] transition-colors"
                data-testid="about-phone"
              >
                +1 (323) 220-4640
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
